"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeTitle = changeTitle;
var _context = require("../context");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Change Title Handler
 * - Changes the SDK IFRAME title
 *
 * @module core-bootstrap-change-title-handler
 */

/**
 * Changes the title of the specified iframe
 *
 * @param {*} data The new title of the iframe
 * @param {*} id iframeEntryId The ID of the iframe handle
 * @return {boolean} true if title was set, false otherwise
 */
function changeTitle(data, id) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return false;
  }
  var title = data.newTitle;
  if (iframeEntry.element && title) {
    iframeEntry.element.title = title;
    return true;
  }
  return false;
}
//# sourceMappingURL=change-title.js.map